module.exports = __webpack_public_path__ + "static/flight-871167e73ef58c8bb31d55a3a690bb2d.png";